// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"616":"12a166fd","3836":"363026c4","3876":"d35f6205","4529":"12a166fd","5346":"12a166fd","5396":"72a18426","6992":"d3732aca","9846":"12a166fd"}[chunkId] + ".chunk.css";
};